import { InputField } from 'lib/iterable-hook-form';
import {
  IntegrationFormField,
  useIntegrationFormContext,
} from 'modules/mobileApps/context/integrationForm';
import { FormField, FormFieldProps } from 'ui/formField';
import { getFormErrorMessages } from '../../utils';

type Props = Omit<FormFieldProps, 'children'> & { name: IntegrationFormField };

export const TextInputField = ({ helpText, labelText, name, ...props }: Props) => {
  const {
    formState: { errors },
  } = useIntegrationFormContext();

  const errorMessages = getFormErrorMessages(errors);

  return (
    <FormField
      data-test="text-input-form-field"
      errorText={errorMessages[name]}
      hasError={!!errorMessages[name]}
      helpText={!errorMessages[name] && helpText}
      labelText={labelText}
      {...props}
    >
      <InputField name={name} />
    </FormField>
  );
};
